module.exports = __webpack_public_path__ + "static/img/becas2021.92dec1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/relaciones-institucionales-en/becas2021.png
// module id = AX/Z
// module chunks = 0